import React, { useState } from "react";
// import { styled } from '@mui/material/styles';
import { Add } from "@mui/icons-material";
import { Button, Drawer, Toolbar, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { ToastContainer } from "react-toastify";

import { Box } from "@mui/system";
import { uploadProductsExcel } from "../../apis/Product";
import { UploadDrawer } from "../../components/CommonFunctions/UploadDrawer";
import DataTable from "../../components/Products/ProductTable";
import { NewEditProductDrawer } from "../UniverisalCart/components/Products/NewEditProductDrawer";

const useStyles = makeStyles()((theme) => ({
    title: {
        flexGrow: 1,
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "block",
        },
    },
}));

export const Products = () => {
    const { classes } = useStyles();
    const [addOpen, setAddOpen] = React.useState(false);
    const [, setTitle] = React.useState("Add");
    const [rows, setRows] = React.useState([]);
    const [, setProduct] = React.useState({});

    const [isUploadDrawerOpen, setIsUploadDrawerOpen] = useState(false);

    const handleAddProduct = () => {
        setTitle("Add");
        setProduct({});
        setAddOpen(true);
    };

    return (
        <>
            <Box px={5}>
                <Toolbar>
                    <Typography className={classes.title} variant="h4" noWrap />
                    <Button
                        onClick={() => handleAddProduct()}
                        startIcon={<Add />}
                        variant="contained"
                        color="primary"
                    >
                        Add Products
                    </Button>
                    <Button
                        onClick={() => setIsUploadDrawerOpen(true)}
                        startIcon={<Add />}
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: 20 }}
                    >
                        Add Products Via Sheet
                    </Button>
                </Toolbar>
                <ToastContainer style={{ width: "600px" }} />
                <DataTable rows={rows} />
                {/* <Drawer
					anchor="right"
					open={addOpen}
					onClose={() => setAddOpen(false)}
				>
					<EditProductDrawer
						title={title}
						setEditOpen={setAddOpen}
						product={product}
						setRows={setRows}
						page={page}
						rowsCount={rowsCount}
					/>
				</Drawer> */}
                {/* <NewEditProductDrawer
					title={title}
						setEditOpen={setAddOpen}
						product={product}
						edit={false}
						 fromGroup
						 setProducts
				/> */}
                <NewEditProductDrawer
                    setEditOpen={setAddOpen}
                    editOpen={addOpen}
                    edit={false}
                    setProducts={setRows}
                    fromGroup={false}
                />
                <Drawer
                    anchor="right"
                    open={isUploadDrawerOpen}
                //   onClose={() => setIsUploadDrawerOpen(false)}
                >
                    <UploadDrawer
                        uploadExcel={uploadProductsExcel}
                        setIsUploadDrawerOpen={setIsUploadDrawerOpen}
                    />
                </Drawer>
            </Box>
        </>
    );
};
